<div class="container">
  <div class="header">
    CodeLinkage
  </div>
  <div class="content">
    <div class="content_top">
      <p>Project :</p>
      <mat-select id="selectionPanel" [(ngModel)]="selectedProjectId" (selectionChange)="onProjectChange($event.value)">
        <mat-option id="optionFirst" [value]="''">Select
        </mat-option>
        <mat-option id="optionAll" *ngFor="let option of projectsOptions" [value]="option.id">
          {{ option.name}}
        </mat-option>
      </mat-select>
    </div>
    <div class="content_bottom">
      <div class="content_bottom_right">
        <div class="card">
          <div class="heading">
            <p>Project Managment Details</p>
            <a (click)="openPopup('projectManagement')" [featureActionState]="'CODE_REVIEW'"><svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
                width="16" data-view-component="true" class="octicon octicon-plus">
                <path
                  d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z">
                </path>
              </svg></a>
          </div>
          <div class="list">
            <ul>
              <li *ngFor="let option of projectCodelinkageSettingList">
                <p>{{ option.name }}</p>
                <mat-icon (click)="deleteProject(option)" [featureActionState]="'CODE_REVIEW'">close</mat-icon>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_bottom_left">
        <div class="card">
          <div class="heading">
            <p>Technical Details</p>
            <a (click)="openPopup('technical')" [featureActionState]="'CODE_REVIEW'"><svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
                width="16" data-view-component="true" class="octicon octicon-plus">
                <path
                  d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z">
                </path>
              </svg></a>
          </div>
          <div class="list">
            <ul>
              <li *ngFor="let option of technicalCodelinkageSettingList">
                <p>{{ option.name }}</p>
                <mat-icon (click)="deleteTechnicalDetails(option)" [featureActionState]="'CODE_REVIEW'">close</mat-icon>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button (click)="onSave()" [featureActionState]="'CODE_REVIEW'">Save</button>
      <!-- <button>Cancel</button> -->
    </div>
  </div>
</div>

<div class="popup" *ngIf="isPopupVisible">
  <div class="popup_box">
    <div class="popup_header">
      <p>{{title}}</p>
      <mat-icon (click)="closePopup()">close</mat-icon>
    </div>
    <div class="popup_content">
      <div class="popup_content_top">
        <form (ngSubmit)="onSubmit(myForm.value)" #myForm="ngForm">
          <div class="row">
            <p>Name</p><input type="text" id="name" name="name" [(ngModel)]="fieldName" required>
          </div>
          <div class="row">
            <p>Is data splitable</p>
            <input type="checkbox" id="isDataSplitable" name="is_data_splitable" [(ngModel)]="isSplitEnabled">
          </div>
          <div class="row">
            <p>Split by</p><input type="text" id="splitBy" name="split_by" [(ngModel)]="splitByData" [disabled]="!isSplitEnabled">
          </div>
          <div class="row">
            <p>Level</p><input type="number" id="level" name="level" [(ngModel)]="fieldLevel">
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>